namespace NearbyBuyersTestIds {
  export const SAVE_TO_LIST_MODAL_BUTTON = 'save-to-list-modal-button'
}

export default NearbyBuyersTestIds
